import { post } from '@_shared/config';

export function postFeedback(opinion: string) {
	return post('/settings/support/opinion', {
		content: opinion,
	});
}
